import { useState, useEffect } from "react";

const useMaxSquareDimensions = () => {
  const [dimensions, setDimensions] = useState<{ width: number; height: number }>({ width: 1920, height: 1080 });

  useEffect(() => {
    const calculateDimensions = () => {
      const screenWidth = window.innerWidth;
      const screenHeight = window.innerHeight;

      const widthRatio = screenWidth / 1920;
      const heightRatio = screenHeight / 1080;

      if (widthRatio < heightRatio) {
        setDimensions({
          width: screenWidth,
          height: Math.floor((screenWidth * 1080) / 1920),
        });
      } else {
        setDimensions({
          width: Math.floor((screenHeight * 1920) / 1080),
          height: screenHeight,
        });
      }
    };

    calculateDimensions();

    window.addEventListener("resize", calculateDimensions);

    return () => window.removeEventListener("resize", calculateDimensions);
  }, []);

  return dimensions;
};

export default useMaxSquareDimensions;
